import Component from '@bythepixel/component-loader';

const DEFAULTS = {
  previewImage: '[data-matterport-preview]',
  previewImageFadeClass: 'section-matterport__preview--fade',
  matterportIframe: 'data-matterport-iframe',
};

export default class Matterport extends Component {
  static selector = '[data-comp-matterport]'

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    Object.assign(this.$options, DEFAULTS, options);
    this.previewImage = this.$container.querySelector(`${this.$options.previewImage}`);
    this.matterportIframe = this.$container.querySelector(`[${this.$options.matterportIframe}]`);
    this.init();
  }

  init() {
    this.addPreviewImageListener();
  }

  addPreviewImageListener() {
    this.previewImage.addEventListener('click', () => {
      this.fadePreviewImage();
      this.addIframeSrc();
    });
  }

  fadePreviewImage() {
    this.previewImage.classList.add(this.$options.previewImageFadeClass);
  }

  addIframeSrc() {
    const dataSrcIframe = this.matterportIframe.getAttribute(this.$options.matterportIframe);
    const autoPlay = '&play=1';
    this.matterportIframe.setAttribute('src', dataSrcIframe + autoPlay);
  }
}
